
import { Component, signal, inject, AfterViewInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})
export class App implements AfterViewInit {
  protected readonly title = signal('guia-noivas');
  private router = inject(Router);

  ngAfterViewInit() {
    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) {
        // Scroll already handled by router config; ensure focus for accessibility
        const main = document.getElementById('main-content');
        if (main) {
          // Using setTimeout to allow view to render before focus
          setTimeout(() => main.focus(), 0);
        }
      }
    });
  }
}
